// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"a9503e0c96caea8d87b4","873":"fb000e39e98b98a86fbc"}[chunkId] + ".js";
};